/**
 * @file ProductNote.tsx
 * @description Пояснение в панели элемента данных товара (phase19.16 Р2а;
 * uiux-design-r2a §3): откуда берутся данные («Сведения берутся из товара»,
 * «Характеристики заполняются в карточке товара», «Реквизиты магазина — из
 * профиля») и ссылка туда, где их правят (`useProductNoteLinks`).
 */

import type { ReactNode } from "react";
import { Link } from "react-router";

import type { NoteLink } from "../../../../../hooks/site-builder/useProductNoteLinks";

export function ProductNote({ children, link }: { children: ReactNode; link?: NoteLink | null }) {
  return (
    <p className="type-caption flex flex-wrap items-center gap-x-2 rounded-lg bg-surface-low px-3 py-2 text-on-surface-variant">
      <span>{children}</span>
      {link ? (
        <Link to={link.to} className="inline-flex min-h-12 items-center font-medium text-primary hover:underline">
          {link.label}
        </Link>
      ) : null}
    </p>
  );
}
